import React, { ReactNode, FormEvent } from "react";
import Modal from "react-modal";
import "./CustomModal.css";

// Bind modal to the appElement for accessibility
Modal.setAppElement("#root");

interface CustomModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  title: string;
  children: ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  onRequestClose,
  onSubmit,
  title,
  children,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="My Modal"
      className="custom-modal-content"
    >
      <h2 className="modal-title">{title}</h2>
      {onSubmit ? (
        <form onSubmit={onSubmit} className="modal-form">
          {children}
          <button type="submit" className="modal-button">
            Submit
          </button>
          <button
            type="button"
            onClick={onRequestClose}
            className="modal-button"
          >
            Close
          </button>
        </form>
      ) : (
        <div className="modal-body">{children}</div>
      )}
    </Modal>
  );
};

export default CustomModal;
